import { EventSourceParserStream } from 'eventsource-parser/stream';
import { throwConnectionError } from '#connection/connection.ts';
import { toSseEvent } from './reader.helpers.ts';
import type { TSseEvent, TSseReadOptions } from './reader.types.ts';

export const readEvents = (
  body: ReadableStream<Uint8Array<ArrayBuffer>>,
  { signal, onRetry, onClose }: TSseReadOptions = {},
): AsyncIterable<TSseEvent> => {
  const iterate = async function* (): AsyncGenerator<TSseEvent> {
    const reader = body
      .pipeThrough(new TextDecoderStream(), { signal })
      .pipeThrough(new EventSourceParserStream({ onRetry }), { signal })
      .getReader();

    try {
      for (;;) {
        const { done, value } = await reader.read();

        if (done) {
          return;
        }

        yield toSseEvent(value);
      }
    } catch (cause) {
      throwConnectionError(cause);
    } finally {
      await reader.cancel().catch(() => undefined);
      onClose?.();
    }
  };

  return { [Symbol.asyncIterator]: iterate };
};
